module.exports = __webpack_public_path__ + "img/3_goje.0617a6d2.jpg";